// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mailing-item-info {
    padding: 0 1rem;
    min-width: 60rem;
    height: 100%;
    overflow: auto;
}

.mailing-table th {
    text-align: center;
}

th.mailing-item-header__contact {
    text-align: left;
}

.mailing-table > tbody > tr > td {
    max-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.mailing-item-info__avatar {
    min-width: 6.4rem;
    padding-left: 1rem;
}

.mailing-item-info__messenger {
    width: 30%;
    min-width: 16rem;
    text-align: left;
}

.mailing-item__mailing-status {
    min-width: 10rem;
}

.mailing-item-info__link {
    min-width: 10rem;
}

.mailing-item-info__name-block {
    width: 100%;
    float: left;
    display: block;
}

.mailing-item-info__name-label {
    float: left;
    display: block;
    min-width: 7.2rem;
    height: 100%;
    margin-top: 1.8rem;
    margin-right: 2rem;
}

.mailing-item-info__create-mailing {
    display: flex;
    flex-direction: row;
}

.mailing-item-info__text-label {
    float: left;
    min-width: 12rem;
    height: 100%;
    margin-top: 1.8rem;
    margin-right: 4rem;
    text-align: end;
}

.mailing-item-info__text-input {
    width: 65% !important;
    text-align: left;
    float: left;
    height: 7.2rem;
}

.mailing-item-info__bot-label {
    float: left;
    text-align: right;
    min-width: 9rem;
    height: 100%;
    margin-top: 1.8rem;
    margin-right: 4%;
}

.mailing-item-info__sending-type-label {
    float: left;
    text-align: right;
    min-width: 9rem;
    height: 100%;
    margin-top: 1.8rem;
    margin-right: 2%;
}

.mailing-item-info__sending-type-field {
    display: flex;
    margin-top: 1rem;
    margin-bottom: 2rem;
    float: left;
    width: 100%;
}

.mailing-item-info__bot-input {
    display: block;
    width: fit-content;
    text-align: left;
}

.mailing-item-info__additional-data-label {
    float: left;
    display: block;
    min-width: 7.2rem;
    height: 100%;
    margin-top: 1.8rem;
    margin-right: 2rem;
}

.mailing-item-info__additional-data-input {
    width: 65% !important;
    text-align: left;
    float: left;
    height: 7.2rem;
}
.mailing-item-info__link-text-block input.mailing-item-info__additional-data-input {
    padding-bottom: 5px;
    height: auto !important;
    margin-top: 19px;
}

.mailing-item-info__save-block {
    float: right;
}

.mailing-item-info__channel-sent-label {
    display: inline-block;
    vertical-align: 0.8rem;
}

.mailing-item-info__chat-link {
    cursor: pointer;
}

.mailing-item__mailing-status{
    width: 30%;
}

.search-type-tabs-wrapper {
    margin: 1.5rem 4rem;
    height: 4rem;
    width: fit-content;
    white-space: nowrap;
    border-bottom: 1px solid rgb(161, 161, 161);
    min-height: 4rem;
    line-height: 4rem;
}

.search-type-tabs-wrapper span{
    margin-left: 1.6rem;
    margin-right: 1.6rem;
    font-family: Arial, Helvetica, sans-serif;
    font-size: medium;
    cursor: pointer;
    padding-bottom: 0.8rem;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    margin-top: auto;
}

.search-type-tabs-wrapper span.active{
    font-weight: bold;
    border-bottom: 2px solid #26a69a;
}`, "",{"version":3,"sources":["webpack://./src/app/mailing/mailing-main/mailing-list/mailing-item-info/MailingItemInfo.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,yCAAyC;IACzC,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;AACpC","sourcesContent":[".mailing-item-info {\r\n    padding: 0 1rem;\r\n    min-width: 60rem;\r\n    height: 100%;\r\n    overflow: auto;\r\n}\r\n\r\n.mailing-table th {\r\n    text-align: center;\r\n}\r\n\r\nth.mailing-item-header__contact {\r\n    text-align: left;\r\n}\r\n\r\n.mailing-table > tbody > tr > td {\r\n    max-width: 0;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.mailing-item-info__avatar {\r\n    min-width: 6.4rem;\r\n    padding-left: 1rem;\r\n}\r\n\r\n.mailing-item-info__messenger {\r\n    width: 30%;\r\n    min-width: 16rem;\r\n    text-align: left;\r\n}\r\n\r\n.mailing-item__mailing-status {\r\n    min-width: 10rem;\r\n}\r\n\r\n.mailing-item-info__link {\r\n    min-width: 10rem;\r\n}\r\n\r\n.mailing-item-info__name-block {\r\n    width: 100%;\r\n    float: left;\r\n    display: block;\r\n}\r\n\r\n.mailing-item-info__name-label {\r\n    float: left;\r\n    display: block;\r\n    min-width: 7.2rem;\r\n    height: 100%;\r\n    margin-top: 1.8rem;\r\n    margin-right: 2rem;\r\n}\r\n\r\n.mailing-item-info__create-mailing {\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.mailing-item-info__text-label {\r\n    float: left;\r\n    min-width: 12rem;\r\n    height: 100%;\r\n    margin-top: 1.8rem;\r\n    margin-right: 4rem;\r\n    text-align: end;\r\n}\r\n\r\n.mailing-item-info__text-input {\r\n    width: 65% !important;\r\n    text-align: left;\r\n    float: left;\r\n    height: 7.2rem;\r\n}\r\n\r\n.mailing-item-info__bot-label {\r\n    float: left;\r\n    text-align: right;\r\n    min-width: 9rem;\r\n    height: 100%;\r\n    margin-top: 1.8rem;\r\n    margin-right: 4%;\r\n}\r\n\r\n.mailing-item-info__sending-type-label {\r\n    float: left;\r\n    text-align: right;\r\n    min-width: 9rem;\r\n    height: 100%;\r\n    margin-top: 1.8rem;\r\n    margin-right: 2%;\r\n}\r\n\r\n.mailing-item-info__sending-type-field {\r\n    display: flex;\r\n    margin-top: 1rem;\r\n    margin-bottom: 2rem;\r\n    float: left;\r\n    width: 100%;\r\n}\r\n\r\n.mailing-item-info__bot-input {\r\n    display: block;\r\n    width: fit-content;\r\n    text-align: left;\r\n}\r\n\r\n.mailing-item-info__additional-data-label {\r\n    float: left;\r\n    display: block;\r\n    min-width: 7.2rem;\r\n    height: 100%;\r\n    margin-top: 1.8rem;\r\n    margin-right: 2rem;\r\n}\r\n\r\n.mailing-item-info__additional-data-input {\r\n    width: 65% !important;\r\n    text-align: left;\r\n    float: left;\r\n    height: 7.2rem;\r\n}\r\n.mailing-item-info__link-text-block input.mailing-item-info__additional-data-input {\r\n    padding-bottom: 5px;\r\n    height: auto !important;\r\n    margin-top: 19px;\r\n}\r\n\r\n.mailing-item-info__save-block {\r\n    float: right;\r\n}\r\n\r\n.mailing-item-info__channel-sent-label {\r\n    display: inline-block;\r\n    vertical-align: 0.8rem;\r\n}\r\n\r\n.mailing-item-info__chat-link {\r\n    cursor: pointer;\r\n}\r\n\r\n.mailing-item__mailing-status{\r\n    width: 30%;\r\n}\r\n\r\n.search-type-tabs-wrapper {\r\n    margin: 1.5rem 4rem;\r\n    height: 4rem;\r\n    width: fit-content;\r\n    white-space: nowrap;\r\n    border-bottom: 1px solid rgb(161, 161, 161);\r\n    min-height: 4rem;\r\n    line-height: 4rem;\r\n}\r\n\r\n.search-type-tabs-wrapper span{\r\n    margin-left: 1.6rem;\r\n    margin-right: 1.6rem;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    font-size: medium;\r\n    cursor: pointer;\r\n    padding-bottom: 0.8rem;\r\n    -moz-user-select: none;\r\n    -khtml-user-select: none;\r\n    user-select: none;\r\n    margin-top: auto;\r\n}\r\n\r\n.search-type-tabs-wrapper span.active{\r\n    font-weight: bold;\r\n    border-bottom: 2px solid #26a69a;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
